import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class AccountManagmentGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var accountManagementGrid = this;
		setTimeout(function(){
			accountManagementGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var accountManagementGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-combo-box',
					itemid: 'accountType',
					'class': 'spacer-toolbar-item',
					label: 'Account Type',
					'item-value-path': 'code',
					'item-label-path': 'description',
					'clear-button-visible': true,
					placeHolder: 'All',
					postinit: function(combo) {
						Service.getLookupService().getLookupValues('ManagedAccountType').then(function(data){
							var items = [{ code: '', description: 'All' }];
							data.forEach(function(item) {
								items.push(item);
							});
							combo.items = items;
							combo.value = '';
						});
					},
					listeners: {
						change: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'vaadin-button',
					itemid: 'details',
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:info-circle-o', ' Details')
					],
					listeners: {
						click: function() {
							if (grid.selectedItems[0]) {
								actionViewDetails(grid.selectedItems[0]);
							}
						}
					}
				}									
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [								
				{						
					path: 'companyId',
					header: 'Company Id',
					width: '7em'
				},	
				{						
					path: 'companyName',
					header: 'Company Name',
					width: '7em'
				},
				{
					path: 'managedAccountTypeDescription',
					header: 'Account Type',
					width: '8em'
				},
				{						
					path: 'numberOfOutstandingFailedTasks',
					header: 'Task Failures',
					width: '7em'
				},
				{						
					path: 'numberOfSystemSuspendedFeeds',
					header: 'System Suspended Feeds',
					width: '7em'
				},
				{						
					path: 'closeReportStatuses',
					header: 'Close Report Status',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.closeReportStatuses.length === 0) {
							root.innerHTML = '0 active report sets';
						} else {
							var status = [];
							rowData.item.closeReportStatuses.forEach(function (closeStat) {
								status.push(closeStat.setName + ': ' + (closeStat.completedInCurrentPeriod ? 'Complete' : 'Outstanding'));
							});
							root.innerHTML = status.join('<br>');
						}
					}					
				},
				{						
					path: 'lastFileUploadDts',
					header: 'Last File Upload Dts',
					width: '7em',
					renderer: function(root, column, rowData) {						
						if (rowData.item.lastFileUploadDts) {
							var date = TimeUtil.parseDate(rowData.item.lastFileUploadDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);	
						} else {
							root.innerHTML = 'N/A';
						}
					}
				},
				{						
					path: 'dataFeeds',
					header: 'Data Feeds',
					width: '10em',
					renderer: function(root, column, rowData) {
						var feeds = rowData.item.dataFeeds || [];
						var needsAttention = (rowData.item.numberOfOutstandingFailedTasks > 0)
							|| (rowData.item.numberOfSystemSuspendedFeeds > 0)
							|| feeds.some(function(feed) {
								return feed.status === 'Cautions'
									|| feed.status === 'FAIL'
									|| feed.numberRecentFails > 0;
							});
						var names = feeds.map(function(feed) {
							return feed.name || 'Feed';
						});
						var html = '<span>' + (names.length ? names.join('<br>') : '0 active') + '</span>';
						if (needsAttention) {
							html += ' <vaadin-icon icon="vaadin:warning" style="color: #c47d00; width: 18px; height: 18px;" title="Needs attention"></vaadin-icon>';
						}
						root.innerHTML = html;
					}
				},
				{						
					path: 'unitCounts',
					header: 'Unit Counts',
					width: '12em',
					renderer: function(root, column, rowData) {
						var unitCounts = rowData.item.unitCounts;
						var text = '<span style="">Tractors: ' + 
								unitCounts.activeTractorCount + '<br> Trailers: ' +
								unitCounts.activeTrailerCount + '<br> Drivers: ' +
								unitCounts.activeDriverCount + '<br>' +
								'</span>';
						
						root.innerHTML = text;
					}
				},
				{						
					path: 'openLocks',
					header: 'Open Locks',
					width: '7em',
					renderer: function(root, column, rowData) {
						var tags = [];
						rowData.item.openLocks.forEach(function(lock) {
							tags.push(
								'<span class="tag-badge" style="margin: 3px;">' + lock.month + '/' + lock.year + '</span>'
							);
						});
						root.innerHTML = tags.join('');
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					gridSelectionChange();
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				var detailsButton = ElementUtil.query(toolbar, 'details');
				if (grid.selectedItems.length > 0) {
					detailsButton.disabled = false;
				} else {
					detailsButton.disabled = true;
				}
			});
		};	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC'
						};

						var accountType = ElementUtil.query(toolbar, 'accountType').value;
						if (accountType) {
							grid.currentFilter.filterField = 'managedAccountType';
							grid.currentFilter.filterValue = accountType;
						}
						
						var successHandler = function(records) {
							loadMask.remove();
							
							grid.selectedItems = [];
							grid.activeItem = null;						
							grid.items = records.data;
							gridSelectionChange();

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
																		
						Service.getAccountManagementService().getManagedAccounts(grid.currentFilter).then(function(records){
							successHandler(records);
						});
																			
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, grid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				Service.getAccountManagementService().exportManagedAccounts(exportFilter);
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		accountManagementGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		attachWorkspaceFilterState(accountManagementGrid, toolbar, ['accountType'], actionRefresh);

		var actionViewDetails = function(record) {
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Account Details',
				icon: 'vaadin:info-circle-o',
				width: .75,
				height: .8,
				listeners: {
					ready: function() {
						viewWin.show();

						var getDetails = function(item) {
							var feedRows = [];
							(item.dataFeeds || []).forEach(function(feed, index) {
								var lastRun = 'N/A';
								if (feed.lastRunDate) {
									lastRun = TimeUtil.formatDateStandard(TimeUtil.parseDate(feed.lastRunDate));
								}
								feedRows.push({
									key: feed.name || ('Feed ' + (index + 1)),
									value: (feed.status || 'N/A')
										+ ' | Successes: ' + (feed.numberRecentSuccesses || 0)
										+ ' | Fails: ' + (feed.numberRecentFails || 0)
										+ ' | Last Run: ' + lastRun
								});
							});
							var unitCounts = item.unitCounts || {};
							var locks = (item.openLocks || []).map(function(lock) {
								return lock.month + '/' + lock.year;
							}).join(', ');
							var closeReports = (item.closeReportStatuses || []).map(function(status) {
								return status.setName + ': ' + (status.completedInCurrentPeriod ? 'Complete' : 'Outstanding');
							}).join('<br>');
							return [
								{ key: 'Company Id', value: item.companyId },
								{ key: 'Company Name', value: item.companyName },
								{ key: 'Account Type', value: (function() {
									var accountType = item.managedAccountTypeDescription || item.managedAccountType;
									if (!accountType || accountType === 'null') {
										return '(Standard Account)';
									}
									return accountType;
								})() },
								{ key: 'Last File Upload', value: item.lastFileUploadDts ? TimeUtil.formatDateStandard(TimeUtil.parseDate(item.lastFileUploadDts)) : 'N/A' },
								{ key: 'Failed Tasks', value: item.numberOfOutstandingFailedTasks },
								{ key: 'Suspended Feeds', value: item.numberOfSystemSuspendedFeeds },
								{ key: 'Close Reports', value: closeReports || 'None' },
								{ key: 'Tractors', value: unitCounts.activeTractorCount },
								{ key: 'Trailers', value: unitCounts.activeTrailerCount },
								{ key: 'Drivers', value: unitCounts.activeDriverCount },
								{ key: 'Open Locks', value: locks || 'None' }
							].concat(feedRows.length ? feedRows : [{ key: 'Data Feeds', value: '0 active feeds' }]);
						};

						var details = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								{
									tag: 'div',
									slot: 'primary',
									style: 'overflow: auto; height: 100%;',
									children: [
										{
											tag: 'dl-detail-table',
											itemid: 'table',
											style: ''
										}
									]
								},
								{
									tag: 'dl-nextprev-toolbar',
									itemid: 'nextPrev',
									slot: 'footer',
									listeners: {
										ready: function(event) {
											event.target.updateData(grid.items || []);
											event.target.setSelectedRecord('companyId', record.companyId);
										},
										change: function(event) {
											grid.deselectItem(record);
											grid.selectItem(event.detail.item);
											record = event.detail.item;
											grid.activeItem = record;
											ElementUtil.query(details, 'table').updateDetails(getDetails(record));
										}
									}
								}
							]
						});
						viewWin.addToContentElement(details);
						ElementUtil.query(details, 'table').updateDetails(getDetails(record));
					}
				}
			});
		};
		
	}
	
}
customElements.define('dl-account-management-grid', AccountManagmentGrid);
